import styled from 'styled-components';

import { colors, cssBreakpoints } from 'theme';

export const LayoutChildrenContainer = styled.div<{
  $darkMode?: boolean;
  $hasPreFooter: boolean;
}>`
  flex: 1 1 auto;
  padding-bottom: ${(props) => (props.$hasPreFooter ? 0 : '36px')};
  position: relative;

  ${(props) =>
    props.$darkMode ? `background: ${colors.backgroundGrey}` : undefined};
  margin-bottom: ${(props) => (props.$darkMode ? '-1px' : 0)};

  border-bottom: ${(props) =>
    props.$darkMode ? `0px solid ${colors.selectionGrey}` : 'none'};

  @media print {
    border: none;
    flex: none;
    padding-bottom: 0;
    background: transparent;
  }

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    padding-bottom: ${(props) => (props.$hasPreFooter ? 0 : '54px')};
  }
`;
